import React from "react";

function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="27"
      viewBox="0 0 27 27"
    >
      <g
        id="Group_20502"
        data-name="Group 20502"
        transform="translate(0.154 -0.308)"
      >
        <rect
          id="Rectangle_9251"
          data-name="Rectangle 9251"
          width="27"
          height="27"
          transform="translate(-0.154 0.308)"
          fill="none"
        />
        <g
          id="Search_blue"
          data-name="Search blue"
          transform="translate(3.48 2.902)"
        >
          <path
            id="Path_3964"
            data-name="Path 3964"
            d="M22.728,13.614A9.114,9.114,0,1,1,13.614,4.5,9.114,9.114,0,0,1,22.728,13.614Z"
            transform="translate(-4.5 -4.5)"
            fill="none"
            stroke="#596870"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            id="Path_3965"
            data-name="Path 3965"
            d="M30,30l-5.028-5.028"
            transform="translate(-9.464 -9.464)"
            fill="none"
            stroke="#596870"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
}

export default SearchIcon;
